import { RouteConfig } from 'vue-router';

export default (): RouteConfig[] => {
	return [
		{ path: 'decks/browse', name: 'deck-list', component: () => import('@client/views/products/decks/DeckBrowse.vue') },
		{ path: 'decks/collections', name: 'deck-collections', component: () => import('@client/views/products/decks/DeckCollections.vue') },
		{ path: 'decks/:id', name: 'deck-details', component: () => import('@client/views/products/decks/DeckDetails.vue') },
	];
};
